import { foundation } from '../../ui';
import { SKELETON_SURFACE } from './skeletonSurfaces';

let injected = false;

/** Shimmer + reduced-motion fallbacks for Skeleton / ListRowSkeleton. */
export function injectSkeletonKeyframes() {
  if (injected || typeof document === 'undefined') return;
  injected = true;
  const muted = foundation.color.neutral.surfaceMuted;
  const edge = foundation.color.neutral.border;
  const s = document.createElement('style');
  s.setAttribute('data-cvx-skeleton', 'true');
  s.textContent = `
    @keyframes cvx-skeleton-shimmer {
      from { background-position: 200% 0; }
      to { background-position: -200% 0; }
    }
    @keyframes cvx-skeleton-pulse {
      0%, 100% { opacity: 0.4; }
      50% { opacity: 1; }
    }
    .cvx-skeleton-shimmer {
      background: linear-gradient(90deg, ${muted} 0%, ${edge} 50%, ${muted} 100%);
      background-size: 200% 100%;
      animation: cvx-skeleton-shimmer 1.2s linear infinite;
    }
    .cvx-skeleton-pulse {
      background-color: ${muted};
      animation: cvx-skeleton-pulse 1.4s ease-in-out infinite;
    }
    @media (prefers-reduced-motion: reduce) {
      .cvx-skeleton-shimmer,
      .cvx-skeleton-pulse {
        animation: none;
        background: ${muted};
        background-size: auto;
      }
    }
  `;
  document.head.appendChild(s);
}

export function usePrefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

let pdfKeyframesInjected = false;

/** Staggered page reveal for PdfPreviewSkeleton (respects reduced motion). */
export function injectPdfSkeletonKeyframes() {
  if (pdfKeyframesInjected || typeof document === 'undefined') return;
  pdfKeyframesInjected = true;
  const s = document.createElement('style');
  s.setAttribute('data-cvx-pdf-skeleton', 'true');
  s.textContent = `
    @keyframes cvx-pdf-page-in {
      from { opacity: 0; transform: translateY(10px) scale(0.992); }
      to { opacity: 1; transform: translateY(0) scale(1); }
    }
    .cvx-pdf-page-shell {
      animation: cvx-pdf-page-in 0.45s cubic-bezier(0.22, 1, 0.36, 1) both;
    }
    .cvx-pdf-viewport-canvas {
      background: ${SKELETON_SURFACE};
    }
    @media (prefers-reduced-motion: reduce) {
      .cvx-pdf-page-shell { animation: none; }
    }
  `;
  document.head.appendChild(s);
}
